var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeoLocate = function SvgGeoLocate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.998 17.157a7.158 7.158 0 1 0 0-14.315 7.158 7.158 0 0 0 0 14.315Z",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.882 10a3.88 3.88 0 1 1-7.761 0 3.88 3.88 0 0 1 7.76 0Z",
    fill: "#000",
    stroke: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0v2.842M10 17.158V20M0 10h2.842M17.16 10H20",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
};
export default SvgGeoLocate;